<template>
  <v-flex class="about">
    <v-layout align-center>
      <v-btn class="mr-3" dark fab small color="info" @click="$router.go(-1)">
        <v-icon dark>chevron_left</v-icon>
      </v-btn>
      <h1>Bookings calendar</h1>
      <v-spacer />
    </v-layout>
    <v-layout class="pb-3" style="position: relative">
      <v-progress-linear
        v-if="!loaded"
        absolute
        color="info"
        :indeterminate="true"
        class="mt-3"
      />
    </v-layout>
    <v-card class="mt-3">
      <v-toolbar flat color="white">
        <v-btn outlined class="mr-3" @click="setToday"> Today </v-btn>
        <v-btn fab text small @click="prev">
          <v-icon small>arrow_back_ios</v-icon>
        </v-btn>
        <v-btn fab text small @click="next">
          <v-icon small>arrow_forward_ios</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-calendar
        ref="calendar"
        v-model="focus"
        :now="today"
        :value="today"
        type="week"
        :events="events"
        event-color="primary"
        :event-overlap-threshold="9999"
        :min-weeks="1"
        :max-days="5"
        :weekdays="weekdays"
        :first-interval="intervals.first"
        :interval-minutes="intervals.minutes"
        :interval-count="intervals.count"
        :interval-height="intervals.height"
        :interval-style="getStyles"
        :show-interval-label="showIntervalLabel"
        @change="getBookings"
      >
      </v-calendar>
    </v-card>
  </v-flex>
</template>

<script>
import { allBookingsCollection } from '../firebaseConfig.js';
import moment from 'moment';

function defaultDay() {
  let today = moment();
  if (today.isoWeekday() > 5) {
    today = today.add(1, 'weeks').isoWeekday(1);
  }
  return today.toISOString().substr(0, 10);
}

export default {
  name: 'BookingsCalendar',
  data() {
    return {
      today: moment()
        .toISOString()
        .substr(0, 10),
      focus: defaultDay(),
      start: null,
      end: null,
      weekdays: [1, 2, 3, 4, 5],
      intervals: { first: 17, minutes: 30, count: 18, height: 40 },
      loaded: false,
      bookings: []
    };
  },
  computed: {
    currentLocationId() {
      return this.$store.state.currentLocation.id;
    },
    events() {
      let events = [];
      if (this.bookings) {
        this.bookings.forEach(booking => {
          let event = {
            name: booking.room_name || 'booking',
            start: moment
              .unix(booking.start_timestamp)
              .format('YYYY-MM-DD HH:mm'),
            end: moment.unix(booking.end_timestamp).format('YYYY-MM-DD HH:mm'),
            details: booking.booked_for
              ? booking.booked_for.email
              : booking.booked_by.email
          };
          events.push(event);
        });
      }
      return events;
    },
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return '';
      }

      const startMonth = moment(start.month, 'M').format('MMMM');
      const endMonth = moment(end.month, 'M').format('MMMM');
      const suffixMonth = startMonth === endMonth ? '' : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? '' : ' - ' + endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      return `${startMonth} ${startDay} - ${suffixMonth} ${endDay} ${startYear} ${suffixYear}`;
    }
  },
  watch: {
    currentLocationId() {
      this.$router.push('meeting-rooms');
    }
  },
  methods: {
    setToday() {
      this.focus = defaultDay();
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    nth(d) {
      return d > 3 && d < 21
        ? 'th'
        : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
    },
    open(event) {
      alert(event.title);
    },
    getBookings({ start, end }) {
      this.loaded = false;
      this.start = start;
      this.end = end;
      let startTimestamp = moment(start.date).format('X');
      let endTimestamp = moment(end.date).format('X');
      this.$bind(
        'bookings',
        allBookingsCollection(
          this.currentLocationId,
          startTimestamp,
          endTimestamp
        ).orderBy('start_timestamp')
      )
        .then(res => {
          this.bookings = res;
          this.loaded = true;
        })
        .catch(error => {
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error loading rooms: ${error}`
          });
          this.loaded = true;
        });
    },
    showIntervalLabel(interval) {
      return interval.minute === 0;
    },
    getStyles(interval) {
      const inactive =
        interval.weekday === 0 ||
        interval.weekday === 6 ||
        interval.hour < 9 ||
        interval.hour >= 17;
      return {
        backgroundColor: inactive ? 'rgba(0,0,0,0.05)' : undefined,
        borderTop: '1px dashed rgba(0,0,0,0.1)'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.v-calendar {
  margin-top: 15px;
}
</style>
